// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1bZ6P","footer":"ModalInfo_footer__3KP-y"};